import { ajax as request } from '@blade/common';
export const taskList = (data) => request({
    url: '/api/portrait-management/api/v1/batch/tasks',
    method: 'POST',
    data
});
